import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { normalizeImageUrl } from '../utils/imageUrl';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function MSFLogo({ suffix = '', className = '', size = 'md', showText = true }) {
  const [settings, setSettings] = useState(null);
  
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/system/settings`, { withCredentials: true });
        setSettings(res.data);
      } catch (error) {
        console.error('Failed to fetch settings for logo:', error);
        setSettings({});
      }
    };
    fetchSettings();
  }, []);

  const sizeClasses = {
    xs: 'h-4',
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-12',
    xl: 'h-16',
    '2xl': 'h-20',
    '3xl': 'h-24',
  };

  const textSizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-xl',
    xl: 'text-2xl',
    '2xl': 'text-3xl',
    '3xl': 'text-4xl',
  };

  const logoUrl = normalizeImageUrl(settings?.landing_page_logo);
  const heightClass = sizeClasses[size] || sizeClasses.md;
  const textClass = textSizeClasses[size] || textSizeClasses.md;

  if (logoUrl) {
    return (
      <span className={`inline-flex items-center ${className}`}>
        <img 
          src={logoUrl} 
          alt="MSF" 
          className={`${heightClass} object-contain`}
        />
        {suffix && showText && (
          <span className={`ml-1 font-heading font-bold ${textClass}`}>{suffix}</span>
        )}
      </span>
    );
  }

  // Fallback to text
  return (
    <span className={`font-heading font-bold ${textClass} ${className}`}>
      <span className="text-primary">MSF</span>
      {suffix && <span>{` ${suffix}`}</span>}
    </span>
  );
}
